

/**
 * Helper for using feature flags in DM app
 * 
 * - canChoosePractitionerFromAllServiceAtBooking
 *   User can choose any practitioner from "all" service at simplybook booking
 *   if "all" service is aivable 
 *  - 
 *   
 */

class Helper {
  

  /**
   * Check if feature is enabled
   *  
   * featureIsEnabled('canChoosePractitionerFromAllServiceAtBooking')
   * 
   * 
   * 
   * @param {string} featureId
   * @param {any} featureFlags Array
   * @return Boolean
  */
  featureIsEnabled( featureId:string, featureFlags?:any ) {
    
    if( typeof featureFlags === "undefined" ){
      featureFlags = [];
      //let currentAppMode = appState.getState( 'app-main-mode' );
      //featureFlags = currentAppMode.featureFlags;
    }

    let featureEnabled = false;
    
    for( var ii in featureFlags ){
      if( featureFlags[ ii ].featureKey === featureId ){
        if( featureFlags[ ii ].enabled ){
          featureEnabled = true;
        }
      }
    }
    
    return featureEnabled;
  }

}


export default Helper;